module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAKCAYAAADPcbwqAAAAlUlEQVQ4jdXOMQ5BYRQF4bmVQiQqC1DYgMoGJBKxoFfZiF40SmvQkigtQUTPKEj8Ck9U15vu5DQf/ElqS12o82zL19SeuvXVLNtUm9pWdwX4og6yXbWpffVUoA9qJ9tVmzpRrwV6rUa2qza18r2q/EPtZuE+FMASGD/3DZhGxAYeYLNkP3QGhhFxbAoYYA+MmgQGWN0BOhqGbtL2KjYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/white_right.png
// module id = n2WB
// module chunks = 1